module.exports = __webpack_public_path__ + "img/logo-republika.b2d861db.jpg";